import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/pro-regular-svg-icons';

/**
 * FIXME @techdebt - remove padding from wrapper and force that on provided children
 */
export const Button = ({
  secondary,
  icon,
  type,
  displayWide,
  onClick,
  disabled,
  children,
  className,
  id,
  'aria-label': ariaLabel,
  'aria-pressed': ariaPressed,
}) => {
  const isSecondary = secondary ? ' ct-button--secondary' : '';
  const isIcon = icon ? ' ct-button--icon' : '';
  const wide = displayWide ? ' ct-button--wide' : '';
  const buttonType = type ? type : 'button';
  const internalId = secondary ? 'ct-button-secondary' : 'ct-button-primary';

  return (
    <button
      type={buttonType}
      aria-label={ariaLabel}
      aria-pressed={ariaPressed}
      className={`ct-button${isSecondary}${isIcon}${wide} ${className || ''}`}
      onClick={onClick}
      disabled={disabled}
      data-e2e={id || internalId}
    >
      {children}
    </button>
  );
};

export const ButtonX = ({ onClick, disabled, 'aria-label': ariaLabel }) => {
  return (
    <button type="button" aria-label={ariaLabel} disabled={disabled} className="ct-button-x" onClick={onClick}>
      <FontAwesomeIcon icon={faTimes} className="ct-button__icon" />
    </button>
  );
};

export * from 'components/button/button-container';
